import { Icon } from "@wisr/react-ui";
import React from "react";

export const referralTitle = <>Looking for a loan?</>;

export const alternateReferralCopy = (
  <>
    <p>
      You&apos;re not eligible for a Wisr loan right now, but perhaps our
      friends at Driva can help.
    </p>
    <p>
      Driva is an award-winning Australian loan broker who talks to over 30
      different lenders and can help you get the loan you need.
    </p>
  </>
);

export const alternateReferralList = (
  <>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>More than 30+ lenders</p>
    </div>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>No impact to your credit score</p>
    </div>
    <div className="list-item">
      <Icon name="status-tick" size="sm" legacy={false} />
      <p>Personalised rate in 60 secs</p>
    </div>
  </>
);

export const buttonSubtext = <>This won&apos;t impact your credit scores</>;

export const referralDisclaimer = (
  <>
    By continuing you&apos;re giving permission to share your details to Driva.
    If Driva helps you get a loan, Wisr will receive a commission.
  </>
);

export const SCORES_REFERRAL_PRODUCT = "Credit Scores";
